import { CategoryAPI } from '@/clients/product/category.api'
export default {
  namespaced: true,
  state: {
    addPop: false,
    editPop: false,
    editObj: {},
    recommendPop: false,
    recommendObj: {},
    menus: [],
    list: []
  },
  getters: {
    addPop: state => state.addPop,
    editPop: state => state.editPop,
    editObj: state => state.editObj,
    recommendPop: state => state.recommendPop,
    recommendObj: state => state.recommendObj,
    /* `menus` is a list of all the menus in the system. */
    menus: state => state.menus,
    list: state => state.list
  },
  mutations: {
    mutateAddPop(state, data) {
      state.addPop = data
      // If add is on edit is false
      state.editPop = false
    },
    mutateEditPop(state, data) {
      state.editPop = data
      // If Edit is on add is false
      state.addPop = false
    },
    mutateEditObj(state, data) {
      state.editObj = data
    },
    mutateRecommendPop(state, data) {
      state.recommendPop = data
    },
    mutateRecommendObj(state, data) {
      state.recommendObj = data
    },
    SET_MENUS(state, data) {
      state.menus = data
    },
    mutateList(state, data) {
      state.list = data
    },
    clearCategoryState(state) {
      Object.assign(state, require('./reset/category.json'))
    }
  },
  actions: {
    setAddPop(context, data) {
      context.commit('mutateAddPop', data)
    },
    setEditPop(context, data) {
      context.commit('mutateEditPop', data)
    },
    setEditObj(context, data) {
      context.commit('mutateEditObj', data)
    },
    setRecommendPop(context, data) {
      context.commit('mutateRecommendPop', data)
    },
    setRecommendObj(context, data) {
      context.commit('mutateRecommendObj', data)
    },
    async fetchAll({ commit }, locationId) {
      try {
        const {
          data: { payload }
        } = await CategoryAPI.getMenus(locationId)
        commit('SET_MENUS', payload)
      } catch (err) {
        console.log(err)
      }
    },
    async setList(context) {
      const {
        data: { payload }
      } = await CategoryAPI.list()
      context.commit('mutateList', payload)
    }
  }
}
